export default __webpack_public_path__ + "static/media/not_found.84f72ac7.svg";